import { CognitoAuthentication } from "./amplifyAuth";

let cognitoInstance: CognitoAuthentication | null = null;

export function getCognitoSingleton(): CognitoAuthentication {
  if (!cognitoInstance) {
    cognitoInstance = new CognitoAuthentication();
  }

  return cognitoInstance;
}

export function resetCognitoSingleton(): void {
  cognitoInstance = null;
}
